export enum LocationType {
  Outside,
  PitEntrance,
  PitExit,
  Single,
  Multiple
}
